import { CompletionRule } from '../enums/completion-rule.enum';
import { ICreateOfferingActionPayload } from '../interfaces/create-offering.action.payload.interface';

export class CourseOfferingCommand {
    name: string;
    category: {
        id: number;
    };
    type: string;
    section: boolean;
    section_rule: string;
    self_paced: boolean;
    completion_rule?: CompletionRule;
    sections_completion_percentage?: number | null;
    offering_group: {
        id: number;
    };
    tags: { id: string }[];
    managers: { id: string }[];

    constructor(tempTap: ICreateOfferingActionPayload) {
        this.name = tempTap.name;
        this.category = { id: Number(tempTap.category.id) };
        this.type = tempTap.type;
        this.section = tempTap.section;
        this.section_rule = tempTap.sectionRule;
        this.self_paced = tempTap.selfPaced;
        this.offering_group = tempTap.offeringGroup.id ? { id: Number(tempTap.offeringGroup.id) } : null;
        this.tags = tempTap.tags.map((tag) => ({ id: tag.id }));
        this.managers = tempTap.managers?.length ? tempTap.managers.map((manager) => ({ id: manager.id })) : null;

        if (tempTap.completionRule != null) {
            this.completion_rule = tempTap.completionRule;
            this.sections_completion_percentage =
                tempTap.completionRule === CompletionRule.AUTO_PERCENTAGE_OF_SECTIONS ? tempTap.sectionsCompletionPercentage ?? null : null;
        }
    }
}
